module.exports = __webpack_public_path__ + "static/media/Annie_0.d092c149.jpg";